'use client';

import { createContext } from 'react';

type NavLink = { label: string; href: string };

export type MarketingNavLinksSeed = {
  navLinks: NavLink[];
  footerLinks: NavLink[];
};

/**
 * Seed for the marketing nav/footer links rendered on the first paint.
 *
 * Server components fetch `api.marketing.queries.listEnabledNavLinks` and
 * provide the result via this context so that `useMarketingNavLinks()` can
 * render the same list on SSR and on the first client render. Without this,
 * the hook's client-side `useQuery` returns `undefined` during SSR (and on
 * the first render of the client), the hook falls back to hardcoded
 * defaults, and the nav visibly pops/reshuffles once Convex resolves.
 */
export const MarketingNavLinksContext =
  createContext<MarketingNavLinksSeed | null>(null);

export function MarketingNavLinksProvider({
  value,
  children,
}: {
  value: MarketingNavLinksSeed | null;
  children: React.ReactNode;
}) {
  return (
    <MarketingNavLinksContext.Provider value={value}>
      {children}
    </MarketingNavLinksContext.Provider>
  );
}
